import { graphql } from 'react-relay/hooks'
import { useMutation } from 'hooks'

const mutation = graphql`
  mutation useReportDeleteMutation($input: DeleteReportByIdInput!) {
    deleteReportById(input: $input) {
      deletedReportId @deleteRecord
    }
  }
`

export default function useReportDelete() {
  return useMutation(mutation, 'deleteReportById')
}
